import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import LoadJquery from "../helper/LoadJquery";
import WhyChooseUs from "../components/Agency_Components/WhyChooseUs";
import DifficultiesFaced from "../components/Agency_Components/DifficultiesFace";
import ExamCumulativeChart from "../components/Agency_Components/PanIndia";
import GrowthChart from "../components/Agency_Components/GrowthTracjectory";
import CrisisManagement from "../components/Agency_Components/CrisisManagement";
import ModuleCoverage from "../components/Agency_Components/ModuleCoverage";
import ExamProcessInfographic from "../components/Agency_Components/ExaminationProcessManagement";
import ExaminationProcessCards from "../components/Agency_Components/ExaminationProcessCards";
import QualityControlManagement from "../components/Agency_Components/QualityManagementControl";
import ExaminationFeaturesRoadmap from "../components/Agency_Components/OtherExaminationManage";
import SecurityManagement from "../components/Agency_Components/SecurityManagement";
import InventoryManagement from "../components/Agency_Components/InventoryManagement";
import ManpowerManagement from "../components/Agency_Components/ManPowerManagment";
import VisitorTracker from '../components/VisitorTracker';
import useContactForm from '../hooks/useContactForm';

const Agency_Demo = () => {
  // Validation, submit guarding, per-field errors and form analytics all live
  // in the shared hook. The source page name is what lets the admin console
  // attribute this lead to the right page.
  const {
    formData, errors, isLoading, handleSubmit, handleInputChange, fieldProps,
  } = useContactForm("infraservice");

  // Renders the message under a field, and nothing when it is valid.
  const Err = ({ name }) =>
    errors[name] ? (
      <p className="form-field-error" id={`${name}-error`} role="alert">
        <i className="fa-solid fa-circle-exclamation" aria-hidden="true" />{" "}
        {errors[name]}
      </p>
    ) : null;


  // NEW: State for loading

  const circleStyle = {
    background: "linear-gradient(to right, #ffffff, #ff0000)",
    color: "black",
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    fontSize: "18px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
    zIndex: 2,
  };

  const lineStyle = {
    position: "absolute",
    top: "25px",
    left: 0,
    right: 0,
    height: "2px",
    backgroundColor: "red",
    zIndex: 1,
  };

  const milestoneWrapper = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    width: "200px",
    padding: "20px",
    backgroundColor: "white",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    transition: "0.3s ease",
    margin: "10px",
  };

  const dotStyle = {
    width: "10px",
    height: "10px",
    border: "2px solid red",
    borderRadius: "50%",
    background: "white",
    marginTop: "8px",
  };
  // State for counter values
  const [counters, setCounters] = useState({
    clients: 0,
    projects: 0,
    media: 0,
    experience: 0
  });
  
  // Ref for counter section
  const counterRef = useRef(null);

  // Manual count-up function
  const startCountUp = (targetValues, duration = 2000) => {
    const startTime = performance.now();
    const increment = 10; // Update every 10ms

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1); // Normalize to 0-1

      setCounters({
        clients: Math.ceil(targetValues.clients * progress),
        projects: Math.ceil(targetValues.projects * progress),
        media: Math.ceil(targetValues.media * progress),
        experience: Math.ceil(targetValues.experience * progress)
      });

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  };

  // Intersection Observer to trigger count-up when section is visible
  useEffect(() => {
    let hasAnimated = false;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          startCountUp({
            clients: 858,
            projects: 858,
            media: 758,
            experience: 258
          });
          hasAnimated = true;
          observer.disconnect();
        }
      },
      { threshold: [0.1, 0.5] } // Trigger at 10% or 50% visibility
    );

    // Fallback: Start animation if section is already in viewport or observer fails
    const checkInitialVisibility = () => {
      if (counterRef.current && !hasAnimated) {
        const rect = counterRef.current.getBoundingClientRect();
        const isVisible = (
          rect.top >= 0 &&
          rect.top <= (window.innerHeight || document.documentElement.clientHeight)
        );
        if (isVisible) {
          startCountUp({
            clients: 858,
            projects: 858,
            media: 758,
            experience: 258
          });
          hasAnimated = true;
          observer.disconnect();
        }
      }
    };

    // Observe the counter section
    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    // Check visibility after a short delay to handle initial load on mobile
    const timer = setTimeout(checkInitialVisibility, 500);

    return () => {
      clearTimeout(timer);
      if (counterRef.current) {
        observer.unobserve(counterRef.current);
      }
    };
  }, []);

  // NEW: Custom debounce function

  // NEW: Handle input changes

  // NEW: Handle form submission

  // NEW: Debounced submit handler (500ms delay)

  return (
    <div>
      <LoadJquery />
      <VisitorTracker page="infraservice" />
      {/* <!-- tpm-header-area start --> */}
      {/* <!-- tpm-header-area start --> */}

      {/* <!-- tpm-header-area end --/> */}

      {/* <!-- tmp banner area start --> */}
      <div className="tmp-section-gap tmp-banner__agency-wrapper-bg position-relative bg_image">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="banner-inner-content-four">
                <div className="inner-content-banner-four">
                  {/* <!-- video icon --> */}
                  {/* <div
                    className="vedio-icone"
                    data-tmp-cursor="lg"
                    data-tmp-cursor-text="Play Video"
                  >
                    <Link className="video-play-button play-video" to="#">
                      <span></span>
                      <p className="text">Intro Vedio</p>
                    </Link>
                    <div className="video-overlay">
                      <Link className="video-overlay-close">×</Link>
                    </div>
                  </div> */}
                  {/* <!-- video icon --> */}
                  <div className="content-wrapper">
                    <h1 className="title">
                      We Design & Build <br /> <span> Powerfull Website</span>{" "}
                    </h1>
                    <p className="disc">
                      
                    </p>
                    <div className="button-area-banner-one">
                      <Link to="/contact" className="tmp-btn btn-primary">
                        <i className="fa-light fa-users"></i> Get In Touch With
                        Us
                      </Link>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tmp-ocean">
          <div className="ocean">
            <div className="wave"></div>
            <div className="wave"></div>
          </div>
        </div>
      </div>
      {/* <!-- tmp banner area end --> */}

      <div className="best-service-we-provide pt--60 tmp-section-gapBottom">
        <div className="container">
          <h2 className="text-danger text-center title split-collab">Center Audit Management</h2>
          <div className="row g-5">
            <div
              className="col-lg-3 col-md-4 col-sm-6 col-12"
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="service-inner financial-service-inner agency-service feature-service">
                <div>
                  <img
                    style={{
                      height: "80px",
                      width: "80px",
                      marginBottom: "10px",
                      borderRadius: "10px",
                    }}
                    src="images/services/database.svg"
                    alt="corporate_Business_Services_agency"
                  />
                </div>
                <div className="content">
                  <h2 className="title">Database</h2>
                  <p className="description">
                    • Central Database Management
                    <br />• Center Recce
                  </p>
                  <div className="three--dot">
                    <div className="dot dot-one"></div>
                    <div className="dot dot-two"></div>
                    <div className="dot dot-two"></div>
                  </div>
                </div>
               
              </div>
            </div>
            <div
              className="col-lg-3 col-md-4 col-sm-6 col-12"
              data-sal-delay="250"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="service-inner financial-service-inner agency-service feature-service">
                <div>
                  <img
                    style={{
                      height: "80px",
                      width: "80px",
                      marginBottom: "10px",
                      borderRadius: "10px",
                    }}
                    src="images/services/approach.svg"
                    alt="corporate_Business_Services_agency"
                  />
                </div>
                <div className="content">
                  <h2 className="title">Appraoach & Management</h2>
                  <p className="description">
                    • Approach Methodology
                    <br />• Interaction with center
                  </p>
                  <div className="three--dot">
                    <div className="dot dot-one"></div>
                    <div className="dot dot-two"></div>
                    <div className="dot dot-two"></div>
                  </div>
                </div>
              
              </div>
            </div>
            <div
              className="col-lg-3 col-md-4 col-sm-6 col-12"
              data-sal-delay="350"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="service-inner financial-service-inner agency-service feature-service">
                <div>
                  <img
                    style={{
                      height: "80px",
                      width: "80px",
                      marginBottom: "10px",
                      borderRadius: "10px",
                    }}
                    src="images/services/audit.svg"
                    alt="corporate_Business_Services_Agency"
                  />
                </div>
                <div className="content">
                  <h2 className="title">Audit</h2>
                  <p className="description">
                    • Deployment of Manpower
                    <br />• Site Visits & Audit Trails/Reports
                    <br />• Notification of shortfalls & Repeat the process with
                    a client visit
                  </p>
                  <div className="three--dot">
                    <div className="dot dot-one"></div>
                    <div className="dot dot-two"></div>
                    <div className="dot dot-two"></div>
                  </div>
                </div>
              
              </div>
            </div>
            <div
              className="col-lg-3 col-md-4 col-sm-6 col-12"
              data-sal-delay="450"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="service-inner financial-service-inner agency-service feature-service">
                <div>
                  <img
                    style={{
                      height: "80px",
                      width: "80px",
                      marginBottom: "10px",
                      borderRadius: "10px",
                    }}
                    src="images/services/MoU.svg"
                    alt="corporate_Business_Services_agency"
                  />
                </div>
                <div className="content">
                  <h2 className="title">MoU</h2>
                  <p className="description">
                    • Agreement with Client
                    <br />• Mail Information to the rejected Centre (with
                    reason)
                  </p>
                  <div className="three--dot">
                    <div className="dot dot-one"></div>
                    <div className="dot dot-two"></div>
                    <div className="dot dot-two"></div>
                  </div>
                </div>
             
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- trusted client --> */}
      <div className="tmp-section-gapBottom tmp-trusted-clients">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="trusted-clients-agency-wrapper">
                <p className="title">
                  trusted By Over 3500 Of the Worlds Leading Companies
                </p>
                <div className="cilents-agency-wrapper">
                  <div className="single-clients">
                    <img
                      src={require("../assets/images/brand/Bytes-logo.png")}
                      alt="Bytes Image"
                    />
                  </div>
                  <div className="single-clients">
                    <img
                      src={require("../assets/images/brand/Career-Foresight-logo.png")}
                      alt="Career-Foresight Image"
                    />
                  </div>
                  <div className="single-clients">
                    <img
                      src={require("../assets/images/brand/netcom-logo.png")}
                      alt="Netcom Image"
                    />
                  </div>
                  <div className="single-clients">
                    <img
                      src={require("../assets/images/brand/netparam-logo.png")}
                      alt="Netparam Image"
                    />
                  </div>
                  <div className="single-clients">
                    <img
                      src={require("../assets/images/brand/Orlando-Academy-logo.png")}
                      alt="Orlando-Academy Image"
                    />
                  </div>
                  <div className="single-clients">
                    <img
                      src={require("../assets/images/brand/SMART-AGE-COMPUTERS-logo.png")}
                      alt="SMART-AGE-COMPUTERS-logo"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- trusted clients end --> */}

      {/* <!-- Tpm About Area Start  --> */}
      <div className="about-area tmp-section-gapBottom about-style-one">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about-thumbnails">
                <div className="thumbnail">

                  <img src="\assets\images\State_And_City_Wise_Presence\State_And_City_Wise_Presence.png" alt="State_And_City_Wise_Presence" style={{height : "550px" , width : "600px"}}/>    

                  {/* <img
                    src="assets/images/about/01.png"
                    alt="corporate_business"
                  /> */}

                  {/* <div className="image-two">
                    <img
                      src="assets/images/about/03.png"
                      alt="corporate_business"
                    />
                  </div> */}

                  {/* <div className="image-three animated">
                    <img
                      className=""
                      src="assets/images/about/02.png"
                      alt="corporate_business"
                    />
                  </div> */}

                  {/* <div className="square"></div> */}

                  {/* <div className="flower">
                    <img
                      src="assets/images/about/flower.png"
                      alt="Corporate_Business"
                    />
                  </div> */}

                  {/* <div className="product-share">
                    <div className="rating">
                      <div className="number">4.8</div>
                      <div className="stars-group">
                        <div className="star">
                          <i className="fa-solid fa-star"></i>
                          <i className="fa-solid fa-star"></i>
                          <i className="fa-solid fa-star"></i>
                          <i className="fa-solid fa-star"></i>

                          <i className="fa-solid fa-star-half-stroke"></i>
                        </div>
                      </div>
                    </div>
                    <div className="profile-share">
                      <Link
                        to="#"
                        className="avatar"
                        data-tooltip="Mark JOrdan"
                        tabindex="0"
                      >
                        <img
                          src="assets/images/about/4.png"
                          alt="Business_Corporate"
                        />
                      </Link>

                      <Link
                        to="#"
                        className="avatar"
                        data-tooltip="Mark JOrdan"
                        tabindex="0"
                      >
                        <img
                          src="assets/images/about/5.png"
                          alt="Business_Corporate"
                        />
                      </Link>

                      <Link
                        to="#"
                        className="avatar"
                        data-tooltip="Mark JOrdan"
                        tabindex="0"
                      >
                        <img
                          src="assets/images/about/6.png"
                          alt="Business_Corporate"
                        />
                      </Link>

                      <Link
                        to="#"
                        className="avatar"
                        data-tooltip="Mark JOrdan"
                        tabindex="0"
                      >
                        <img
                          src="assets/images/about/7.png"
                          alt="Business_Corporate"
                        />
                      </Link>
                    </div>
                  </div> */}
                </div>

                {/* <!-- video icon --> */}
                {/* <div
                  className="vedio-icone"
                  data-tmp-cursor="lg"
                  data-tmp-cursor-text="Play Video"
                >
                  <Link className="video-play-button play-video" to="#">
                    <span></span>
                  </Link>
                  <div className="video-overlay">
                    <Link className="video-overlay-close">×</Link>
                  </div>
                </div> */}
                {/* <!-- video icon --> */}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-inner">
                <div className="section-head text-align-left section-head-one-side">
                  {/* <div className="section-sub-title">
                    <img
                      src="assets/images/services/section-custom-menubar.png "
                      alt="Corporate_service"
                    />
                    <span className="subtitle">ABOUT US</span>
                  </div> */}
                  <h2 className="title split-collab">
                    <span className="text-danger">PAN INDIA</span> <br />CENTER DETAILS
                  </h2>
                </div>

                {/* <p
                  className="description"
                  data-sal-delay="200"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Curabitur eget ornare quam. Sed sit amet sem sollicitudin,
                  condimentum diam sed, consequat tellus. Quisque ac odio eget
                  ligula gravida efficitur. Nunc facilisis sagittis magna, non
                  venenatis mauris luctus quis.
                </p> */}
                {/* <!-- Prograss bar Start  --> */}
                <div
                  className="single-progress-area progress-stye-one"
                  data-sal-delay="250"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  <div className="progress-top">
                    <p className="name">TOTAL CITIES COVERED</p>
                    <span className="parcent">145</span>
                  </div>
                  <span className="subtitle text-danger">(PAN INDIA)</span>
                  {/* <div className="progress">
                    <div
                      className="progress-bar wow fadeInLeft bg--primary"
                      role="progressbar"
                      style={{ width: " 85%" }}
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div> */}
                </div>
                <div
                  className="single-progress-area progress-stye-one"
                  data-sal-delay="300"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  <div className="progress-top">
                    <p className="name">TOTAL CENTRES COVERED</p>
                    <span className="parcent">340</span>
                  </div>
                  <span className="subtitle text-danger">(PAN INDIA)</span>
                  {/* <div className="progress">
                    <div
                      className="progress-bar wow fadeInLeft bg--primary"
                      role="progressbar"
                      style={{ width: "66%" }}
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div> */}
                </div>
                <div
                  className="single-progress-area progress-stye-one"
                  data-sal-delay="250"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  <div className="progress-top">
                    <p className="name">TOTAL SKILLED MANPOWER</p>
                    <span className="parcent">1000</span>
                  </div>
                  <span className="subtitle text-danger">(PAN INDIA)</span>
                  {/* <div className="progress">
                    <div
                      className="progress-bar wow fadeInLeft bg--primary"
                      role="progressbar"
                      style={{ width: " 85%" }}
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div> */}
                </div>
                {/* <!-- Prograss bar End  --> */}
                <div
                  className="thumbnail-with-title border bg-light"
                  data-sal-delay="350"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  {/* <div className="thumbnail">
                    <img src="assets/images/about/about-with-icon.png" alt="" />
                    <div className="icon">
                      <i className="fa-regular fa-dollar-sign"></i>
                    </div>
                  </div> */}
                  <div className="title p-2" style={{fontSize : "15px"}}>
                    We have a proven track record of conducting successful examinations in Leh Ladakh and the northeastern regions of the country
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!--Tpm About Area End  --> */}

      {/* Old Cards Area Started */}
      {/* <div className="service-area tmp-section-gapBottom">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-12"
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="section-head">
                <div className="section-sub-title center-title">
                  <img
                    src="assets/images/services/section-custom-menubar.png "
                    alt="Business_Consulting_services"
                  />
                  <span>OUR SERVICES</span>
                </div>
                <h2 className="title split-collab">Our Provided Services</h2>
              </div>
            </div>
          </div>
          <div className="row g-5">
            <div
              className="col-lg-4 col-md-6 col-sm-6 col-12"
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="service-inner financial-service-inner agency-service">
                <div className="icon">
                  <img
                    src="assets/images/services/agency-6.svg"
                    alt="corporate_Business_Services_agency"
                  />
                </div>
                <div className="content">
                  <h2 className="title">Database</h2>
                  <p className="description">
                    • Central Database Management
                    <br />• Center Recce
                  </p>
                  <div className="three--dot">
                    <div className="dot dot-one"></div>
                    <div className="dot dot-two"></div>
                    <div className="dot dot-two"></div>
                  </div>
                </div>
                <Link to="/service/details" className="over_link"></Link>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 col-sm-6 col-12"
              data-sal-delay="250"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="service-inner financial-service-inner agency-service">
                <div className="icon">
                  <img
                    src="assets/images/services/agency-1.svg"
                    alt="corporate_Business_Services_agency"
                  />
                </div>
                <div className="content">
                  <h2 className="title">Apporoach & Management</h2>
                  <p className="description">
                    • Approach Methodology
                    <br />• Interaction with center
                  </p>
                  <div className="three--dot">
                    <div className="dot dot-one"></div>
                    <div className="dot dot-two"></div>
                    <div className="dot dot-two"></div>
                  </div>
                </div>
                <Link to="/service/details" className="over_link"></Link>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 col-sm-6 col-12"
              data-sal-delay="350"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="service-inner financial-service-inner agency-service">
                <div className="icon">
                  <img
                    src="assets/images/services/agency-2.svg"
                    alt="corporate_Business_Services_Agency"
                  />
                </div>
                <div className="content">
                  <h2 className="title">Audit</h2>
                  <p className="description">
                    • Deployment of
                        Manpower
                        <br />• Site Visits & Audit
                        Trails/Reports
                        <br />• Notification of
                        shortfalls & Repeat the
                        process with a client
                        visit
                  </p>
                  <div className="three--dot">
                    <div className="dot dot-one"></div>
                    <div className="dot dot-two"></div>
                    <div className="dot dot-two"></div>
                  </div>
                </div>
                <Link to="/service/details" className="over_link"></Link>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 col-sm-6 col-12"
              data-sal-delay="450"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="service-inner financial-service-inner agency-service">
                <div className="icon">
                  <img
                    src="assets/images/services/agency-3.svg"
                    alt="corporate_Business_Services_agency"
                  />
                </div>
                <div className="content">
                  <h2 className="title">    MoU</h2>
                  <p className="description">
                    • Agreement with Client
                    <br />• Mail Information to the
                    rejected Centre (with
                    reason)

                  </p>
                  <div className="three--dot">
                    <div className="dot dot-one"></div>
                    <div className="dot dot-two"></div>
                    <div className="dot dot-two"></div>
                  </div>
                </div>
                <Link to="/service/details" className="over_link"></Link>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 col-sm-6 col-12"
              data-sal-delay="550"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="service-inner financial-service-inner agency-service">
                <div className="icon">
                  <img
                    src="assets/images/services/agency-4.svg"
                    alt="corporate_Business_Services_agency"
                  />
                </div>
                <div className="content">
                  <h2 className="title">Website Design</h2>
                  <p className="description">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod.
                  </p>
                  <div className="three--dot">
                    <div className="dot dot-one"></div>
                    <div className="dot dot-two"></div>
                    <div className="dot dot-two"></div>
                  </div>
                </div>
                <Link to="/service/details" className="over_link"></Link>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 col-sm-6 col-12"
              data-sal-delay="650"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="service-inner financial-service-inner agency-service">
                <div className="icon">
                  <img
                    src="assets/images/services/agency-5.svg"
                    alt="corporate_Business_Services_agency"
                  />
                </div>
                <div className="content">
                  <h2 className="title">Mutual Funds</h2>
                  <p className="description">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod.
                  </p>
                  <div className="three--dot">
                    <div className="dot dot-one"></div>
                    <div className="dot dot-two"></div>
                    <div className="dot dot-two"></div>
                  </div>
                </div>
                <Link to="/service/details" className="over_link"></Link>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* Old Cards Area Ended */}

      {/* New Cards Area Started */}
      <div className="container my-5">
        <h2 className="text-center fw-bold mb-5 text-danger title split-collab">
          MILESTONES
        </h2>

        <div style={{ position: "relative", padding: "40px 0" }}>
          {/* Timeline horizontal line */}
          <div style={lineStyle}></div>

          {/* Milestones container */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              flexWrap: "wrap",
              position: "relative",
              zIndex: 2,
            }}
          >
            {/* Milestone 1 */}
            <div
              style={milestoneWrapper}
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div style={circleStyle}>1</div>
              <div style={dotStyle}></div>
              <h5 className="mt-3 fw-bold text-danger">JAN 2013</h5>
              <p className="text-center">
                Entered in Center based Exam Conduction Domain
              </p>
            </div>

            {/* Milestone 2 */}
            <div
              style={milestoneWrapper}
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div style={circleStyle}>2</div>
              <div style={dotStyle}></div>
              <h5 className="mt-3 fw-bold text-danger">APRIL 2014</h5>
              <p className="text-center">
                Associations with National & International Exam Conductions
                Companies
              </p>
            </div>

            {/* Milestone 3 */}
            <div
              style={milestoneWrapper}
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div style={circleStyle}>3</div>
              <div style={dotStyle}></div>
              <h5 className="mt-3 fw-bold text-danger">JAN 2018</h5>
              <p className="text-center">
                Started Executing Pan India Projects with CDAC ACTS with AFCAT
              </p>
            </div>

            {/* Milestone 4 */}
            <div
              style={milestoneWrapper}
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div style={circleStyle}>4</div>
              <div style={dotStyle}></div>
              <h5 className="mt-3 fw-bold text-danger">FEB 2019</h5>
              <p className="text-center">
                Added CIPET, NTRO and SEBI projects with CDAC
              </p>
            </div>

            {/* Milestone 5 */}
            <div
              style={milestoneWrapper}
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div style={circleStyle}>5</div>
              <div style={dotStyle}></div>
              <h5 className="mt-3 fw-bold text-danger">MARCH 2021</h5>
              <p className="text-center">
                Added ICG officer and Sailor project with CDAC
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* New Cards Area Ended */}

      {/* Exam Entity Cards Started */}
      <div className="tmp-product-area" style={{marginTop:"30px"}}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-head">
                {/* <div className="section-sub-title center-title">
                  <img
                    src="assets/images/services/section-custom-menubar.png"
                    alt="Corporate_service"
                  />
                  <span className="subtitle">OUR PORTFOLIO</span>
                </div> */}
                <h2 className="title split-collab text-danger">
                  We as an exam entity
                </h2>
                <p
                  className="title split-collab text-danger"
                  style={{ fontSize: "18px", fontStyle: "italic" }}
                >
                  "Conduction of Exam is not just a work for us....it’s our
                  Passion"
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container-full">
          <div className="row">
            <div className="col-lg-12">
              {/* Swiper start */}
              <div className="product-swiper-area-one">
                <div className="swiper mySwiper-portfolio-1">
                  <div className="swiper-wrapper">
                    {/* === Card 1 === */}
                    <div className="swiper-slide">
                      {/* paste Card 1 here */}
                      <div
                        className="text-center h-100 position-relative overflow-hidden hover-animation"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "8px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          padding: "20px",
                          minHeight: "300px",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "140px",
                            backgroundColor: "#E74C3C ",
                            zIndex: 0,
                          }}
                        ></div>
                        <h5
                          className="fw-bold mb-4 position-relative text-white"
                          style={{ zIndex: 1, fontSize: "17px" }}
                        >
                          High Expertise <br /> in Exam Vertical
                        </h5>
                        <img
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "white",
                            border: "4px solid #DADADA",
                            zIndex: 1,
                          }}
                          src="../assets/images/Exam_Entity_Icons/Exam_Entity_A1.png"
                          alt=""
                        />

                        <p
                          className="small position-relative"
                          style={{ zIndex: 1 }}
                        >
                          We possess extensive experience in online
                          examinations, spanning over six years.
                        </p>
                      </div>
                    </div>

                    {/* === Card 2 === */}
                    <div className="swiper-slide">
                      {/* paste Card 2 here */}
                      <div
                        className="text-center h-100 position-relative overflow-hidden hover-animation"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "8px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          padding: "20px",
                          minHeight: "300px",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "140px",
                            backgroundColor: "#58D68D",
                            zIndex: 0,
                          }}
                        ></div>
                        <h5
                          className="fw-bold mb-4 position-relative text-white"
                          style={{ zIndex: 1, fontSize: "17px" }}
                        >
                          Top notch <br />
                          InFrastructure
                        </h5>
                        {/* <div
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "#B0B0B0",
                            border: "4px solid white",
                            zIndex: 1,
                          }}
                        >
                          <div
                            style={{
                              width: "60%",
                              height: "60%",
                              backgroundColor: "rgba(0,0,0,0.1)",
                            }}
                          ></div>
                        </div> */}
                        <img
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "white",
                            border: "4px solid #DADADA",
                            zIndex: 1,
                          }}
                          src="../assets/images/Exam_Entity_Icons/Exam_Entity_B1.png"
                          alt=""
                        />
                        <p
                          className="small position-relative"
                          style={{ zIndex: 1 }}
                        >
                          We provide suitable venues and infrastructure to
                          conduct exams.
                        </p>
                      </div>
                    </div>

                    {/* === Card 3 === */}
                    <div className="swiper-slide">
                      {/* Paste Card 3 here */}
                      <div
                        className="text-center h-100 position-relative overflow-hidden hover-animation"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "8px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          padding: "20px",
                          minHeight: "300px",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "140px",
                            backgroundColor: "#82E0AA",
                            zIndex: 0,
                          }}
                        ></div>
                        <h5
                          className="fw-bold mb-4 position-relative text-white"
                          style={{ zIndex: 1, fontSize: "17px" }}
                        >
                          EFFicient
                          <br />
                          Execution
                        </h5>
                        {/* <div
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "#FF3333",
                            border: "4px solid #DADADA",
                            zIndex: 1,
                          }}
                        >
                          <div
                            style={{
                              width: "60%",
                              height: "60%",
                              backgroundColor: "rgba(0,0,0,0.1)",
                            }}
                          ></div>
                        </div> */}
                        <img
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "white",
                            border: "4px solid #DADADA",
                            zIndex: 1,
                          }}
                          src="../assets/images/Exam_Entity_Icons/Exam_Entity_C1.png"
                          alt=""
                        />
                        <p
                          className="small position-relative"
                          style={{ zIndex: 1 }}
                        >
                          We efficiently manage nationwide exam projects,
                          including coordination with centers, invigilators, and
                          manpower for a seamless and equitable examination
                          experience.
                        </p>
                      </div>
                    </div>

                    {/* === Card 4 === */}
                    <div className="swiper-slide">
                      {/* Paste Card 4 here */}
                      <div
                        className="text-center h-100 position-relative overflow-hidden hover-animation"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "8px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          padding: "20px",
                          minHeight: "300px",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "140px",
                            backgroundColor: "#3498DB",
                            zIndex: 0,
                          }}
                        ></div>
                        <h5
                          className="fw-bold mb-4 position-relative text-white"
                          style={{ zIndex: 1, fontSize: "17px" }}
                        >
                          Vigilance & <br />
                          Security
                        </h5>
                        {/* <div
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "#B0B0B0",
                            border: "4px solid white",
                            zIndex: 1,
                          }}
                        >
                          <div
                            style={{
                              width: "60%",
                              height: "60%",
                              backgroundColor: "rgba(0,0,0,0.1)",
                            }}
                          ></div>
                        </div> */}
                        <img
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "white",
                            border: "4px solid #DADADA",
                            zIndex: 1,
                          }}
                          src="../assets/images/Exam_Entity_Icons/Exam_Entity_D1.png"
                          alt=""
                        />
                        <p
                          className="small position-relative"
                          style={{ zIndex: 1 }}
                        >
                          Deployment of trained invigilators to uphold exam
                          integrity, ensure compliance with rules, and prevent
                          malpractice.
                        </p>
                      </div>
                    </div>

                    {/* === Card 5 === */}
                    <div className="swiper-slide">
                      {/* Paste Card 5 here */}
                      <div
                        className="text-center h-100 position-relative overflow-hidden hover-animation"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "8px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          padding: "20px",
                          minHeight: "300px",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "140px",
                            backgroundColor: "#B7950B",
                            zIndex: 0,
                          }}
                        ></div>
                        <h5
                          className="fw-bold mb-4 position-relative text-white"
                          style={{ zIndex: 1, fontSize: "17px" }}
                        >
                          Data <br /> Management
                        </h5>
                        {/* <div
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "#FF3333",
                            border: "4px solid #DADADA",
                            zIndex: 1,
                          }}
                        >
                          <div
                            style={{
                              width: "60%",
                              height: "60%",
                              backgroundColor: "rgba(0,0,0,0.1)",
                            }}
                          ></div>
                        </div> */}
                        <img
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "white",
                            border: "4px solid #DADADA",
                            zIndex: 1,
                          }}
                          src="../assets/images/Exam_Entity_Icons/Exam_Entity_E1.png"
                          alt=""
                        />
                        <p
                          className="small position-relative"
                          style={{ zIndex: 1 }}
                        >
                          Upload required exam data on dedicated servers for
                          further processing.
                        </p>
                      </div>
                    </div>

                    {/* === Card 6 === */}
                    <div className="swiper-slide">
                      {/* Paste Card 6 here */}
                      <div
                        className="text-center h-100 position-relative overflow-hidden hover-animation"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "8px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          padding: "20px",
                          minHeight: "300px",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "140px",
                            backgroundColor: "#0B5345",
                            zIndex: 0,
                          }}
                        ></div>
                        <h5
                          className="fw-bold mb-4 position-relative text-white"
                          style={{ zIndex: 1, fontSize: "17px" }}
                        >
                          Ensure <br />
                          Transparency
                        </h5>
                        {/* <div
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "#B0B0B0",
                            border: "4px solid white",
                            zIndex: 1,
                          }}
                        >
                          <div
                            style={{
                              width: "60%",
                              height: "60%",
                              backgroundColor: "rgba(0,0,0,0.1)",
                            }}
                          ></div>
                        </div> */}
                        <img
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "white",
                            border: "4px solid #DADADA",
                            zIndex: 1,
                          }}
                          src="../assets/images/Exam_Entity_Icons/Exam_Entity_F1.png"
                          alt=""
                        />
                        <p
                          className="small position-relative"
                          style={{ zIndex: 1 }}
                        >
                          We ensure a fair and transparent examination process.
                        </p>
                      </div>
                    </div>

                    {/* === Card 7 === */}
                    <div className="swiper-slide">
                      {/* Paste Card 7 here */}
                      <div
                        className="text-center h-100 position-relative overflow-hidden hover-animation"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "8px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          padding: "20px",
                          minHeight: "300px",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "140px",
                            backgroundColor: "#5DADE2",
                            zIndex: 0,
                          }}
                        ></div>
                        <h5
                          className="fw-bold mb-4 position-relative text-white"
                          style={{ zIndex: 1, fontSize: "17px" }}
                        >
                          Trusted <br /> Partner
                        </h5>
                        {/* <div
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "#FF3333",
                            border: "4px solid #DADADA",
                            zIndex: 1,
                          }}
                        >
                          <div
                            style={{
                              width: "60%",
                              height: "60%",
                              backgroundColor: "rgba(0,0,0,0.1)",
                            }}
                          ></div>
                        </div> */}
                        <img
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "white",
                            border: "4px solid #DADADA",
                            zIndex: 1,
                          }}
                          src="../assets/images/Exam_Entity_Icons/Exam_Entity_A2.png"
                          alt=""
                        />
                        <p
                          className="small position-relative"
                          style={{ zIndex: 1 }}
                        >
                          We have had the privilege of serving esteemed clients
                          from the defense and government sectors.
                        </p>
                      </div>
                    </div>

                    {/* === Card 8 === */}
                    <div className="swiper-slide">
                      {/* Paste Card 8 here */}
                      <div
                        className="text-center h-100 position-relative overflow-hidden hover-animation"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "8px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          padding: "20px",
                          minHeight: "300px",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "140px",
                            backgroundColor: "#A569BD",
                            zIndex: 0,
                          }}
                        ></div>
                        <h5
                          className="fw-bold mb-4 position-relative text-white"
                          style={{ zIndex: 1, fontSize: "17px" }}
                        >
                          Nationwide <br /> Presence
                        </h5>
                        {/* <div
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "#B0B0B0",
                            border: "4px solid white",
                            zIndex: 1,
                          }}
                        >
                          <div
                            style={{
                              width: "60%",
                              height: "60%",
                              backgroundColor: "rgba(0,0,0,0.1)",
                            }}
                          ></div>
                        </div> */}
                        <img
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "white",
                            border: "4px solid #DADADA",
                            zIndex: 1,
                          }}
                          src="../assets/images/Exam_Entity_Icons/Exam_Entity_B2.png"
                          alt=""
                        />
                        <p
                          className="small position-relative"
                          style={{ zIndex: 1 }}
                        >
                          We boasts a significant presence across 28 states and
                          145 cities, having successfully catered to over 10
                          lakh examines.
                        </p>
                      </div>
                    </div>

                    {/* === Card 9 === */}
                    <div className="swiper-slide">
                      {/* Paste Card 9 here */}
                      <div
                        className="text-center h-100 position-relative overflow-hidden hover-animation"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "8px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          padding: "20px",
                          minHeight: "300px",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "140px",
                            backgroundColor: "#E67E22",
                            zIndex: 0,
                          }}
                        ></div>
                        <h5
                          className="fw-bold mb-4 position-relative text-white"
                          style={{ zIndex: 1, fontSize: "17px" }}
                        >
                          Remote area <br />
                          coverage
                        </h5>
                        {/* <div
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "#FF3333",
                            border: "4px solid #DADADA",
                            zIndex: 1,
                          }}
                        >
                          <div
                            style={{
                              width: "60%",
                              height: "60%",
                              backgroundColor: "rgba(0,0,0,0.1)",
                            }}
                          ></div>
                        </div> */}
                        <img
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "white",
                            border: "4px solid #DADADA",
                            zIndex: 1,
                          }}
                          src="../assets/images/Exam_Entity_Icons/Exam_Entity_C2.png"
                          alt=""
                        />
                        <p
                          className="small position-relative"
                          style={{ zIndex: 1 }}
                        >
                          Examinations have been successfully conducted in
                          remote areas with all logistical support.
                        </p>
                      </div>
                    </div>

                    {/* === Card 10 === */}
                    <div className="swiper-slide">
                      {/* Paste Card 10 here */}
                      <div
                        className="text-center h-100 position-relative overflow-hidden hover-animation"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "8px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          padding: "20px",
                          minHeight: "300px",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "140px",
                            backgroundColor: "#7DCEA0",
                            zIndex: 0,
                          }}
                        ></div>
                        <h5
                          className="fw-bold mb-4 position-relative text-white"
                          style={{ zIndex: 1, fontSize: "17px" }}
                        >
                          Autonomous Exam <br />
                          Management
                        </h5>
                        {/* <div
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "#B0B0B0",
                            border: "4px solid white",
                            zIndex: 1,
                          }}
                        >
                          <div
                            style={{
                              width: "60%",
                              height: "60%",
                              backgroundColor: "rgba(0,0,0,0.1)",
                            }}
                          ></div>
                        </div> */}
                        <img
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "white",
                            border: "4px solid #DADADA",
                            zIndex: 1,
                          }}
                          src="../assets/images/Exam_Entity_Icons/Exam_Entity_D2.png"
                          alt=""
                        />
                        <p
                          className="small position-relative"
                          style={{ zIndex: 1 }}
                        >
                          Our examination system operates independently, free
                          from reliance on third-party software.
                        </p>
                      </div>
                    </div>

                    {/* === Card 11 === */}
                    <div className="swiper-slide">
                      {/* Paste Card 11 here */}
                      <div
                        className="text-center h-100 position-relative overflow-hidden hover-animation"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "8px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          padding: "20px",
                          minHeight: "300px",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "140px",
                            backgroundColor: "#8E44AD",
                            zIndex: 0,
                          }}
                        ></div>
                        <h5
                          className="fw-bold mb-4 position-relative text-white"
                          style={{
                            zIndex: 1,
                            fontSize: "17px",
                            minHeight: "48px",
                          }}
                        >
                          Reliability
                        </h5>
                        {/* <div
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "#FF3333",
                            border: "4px solid #DADADA",
                            zIndex: 1,
                          }}
                        >
                          <div
                            style={{
                              width: "60%",
                              height: "60%",
                              backgroundColor: "rgba(0,0,0,0.1)",
                            }}
                          ></div>
                        </div> */}
                        <img
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "white",
                            border: "4px solid #DADADA",
                            zIndex: 1,
                          }}
                          src="../assets/images/Exam_Entity_Icons/Exam_Entity_E2.png"
                          alt=""
                        />
                        <p
                          className="small position-relative"
                          style={{ zIndex: 1 }}
                        >
                          We boast an exceptionally low failure rate, ensured by
                          redundant hardware configurations.
                        </p>
                      </div>
                    </div>

                    {/* === Card 12 === */}
                    <div className="swiper-slide">
                      {/* Paste Card 12 here */}
                      <div
                        className="text-center h-100 position-relative overflow-hidden hover-animation"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "8px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          padding: "20px",
                          minHeight: "300px",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "140px",
                            backgroundColor: "#5DADE2",
                            zIndex: 0,
                          }}
                        ></div>
                        <h5
                          className="fw-bold mb-4 position-relative text-white"
                          style={{ zIndex: 1, fontSize: "17px" }}
                        >
                          Team oF <br /> ProFessionals
                        </h5>
                        {/* <div
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "#B0B0B0",
                            border: "4px solid white",
                            zIndex: 1,
                          }}
                        >
                          <div
                            style={{
                              width: "60%",
                              height: "60%",
                              backgroundColor: "rgba(0,0,0,0.1)",
                            }}
                          ></div>
                        </div> */}
                        <img
                          className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            backgroundColor: "white",
                            border: "4px solid #DADADA",
                            zIndex: 1,
                          }}
                          src="../assets/images/Exam_Entity_Icons/Exam_Entity_F2.png"
                          alt=""
                        />
                        <p
                          className="small position-relative"
                          style={{ zIndex: 1 }}
                        >
                          Our team comprises highly skilled and experienced
                          professionals, exceling in Agile methodologies.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Swiper controls */}
                  <div className="swiper-pagination"></div>
                  <div
                    className="swiper-button-next"
                    data-tmp-cursor="md transparent fw-bold"
                    data-tmp-cursor-text="Next"
                  ></div>
                  <div
                    className="swiper-button-prev"
                    data-tmp-cursor="md transparent fw-bold"
                    data-tmp-cursor-text="Prev"
                  ></div>
                </div>
              </div>
              {/* Swiper end */}
            </div>
          </div>
        </div>
      </div>
      {/* Exam Entity Cards Ended */}

      {/* <!-- tmp product area start --> */}

      <div className="tmp-product-area" style={{marginTop : "60px"}}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-head">
                {/* <div className="section-sub-title center-title">
                  <img
                    src="assets/images/services/section-custom-menubar.png "
                    alt="Corporate_service"
                  />
                  <span className="subtitle">OUR PORTFOLIO</span>
                </div> */}
                <h2 className="title split-collab text-danger">
                  Let's Check Our Best Works{" "}
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container-full">
          <div className="row">
            <div className="col-lg-12">
              {/* <!-- product swiper area start --> */}
              <div>
                <div className="swiper mySwiper-portfolio-1">
                  <div className="swiper-wrapper">
                    <div className="swiper-slide">
                      {/* <!-- single product area start --> */}
                      <div
                        className="signle-product-start"
                        
                        
                      >
                          <img
                            // src="assets/images/portfolio/portfolio-1.png"
                            src = "../assets/images/Exam_Snapshots/Picture1.png"
                            alt="corporate_business"
                            style={{height : "300px" , width : "400px"}}
                          />
                        
                        {/* <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Corporate Design</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div> */}
                      </div>
                      {/* <!-- single product area end --> */}
                    </div>
                    <div className="swiper-slide">
                      {/* <!-- single product area start --> */}
                      <div
                        className="signle-product-start"
                        
                        
                      >
                       
                          <img
                            // src="assets/images/portfolio/portfolio-2.png"
                            src = "../assets/images/Exam_Snapshots/Picture2.png"
                            alt="corporate_business"
                            style={{height : "300px" , width : "400px"}}
                          />
                      
                        {/* <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Executive Design Kit</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div> */}
                      </div>
                      {/* <!-- single product area end --> */}
                    </div>
                    <div className="swiper-slide">
                      {/* <!-- single product area start --> */}
                      <div
                        className="signle-product-start"
                        
                        
                      >
                       
                          <img
                            // src="assets/images/portfolio/portfolio-3.png"
                            src = "../assets/images/Exam_Snapshots/Picture3.png"
                            alt="corporate_business"
                            style={{height : "300px" , width : "400px"}}
                          />
                     
                        {/* <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Business Theme Pack</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div> */}
                      </div>
                      {/* <!-- single product area end --> */}
                    </div>
                    <div className="swiper-slide">
                      {/* <!-- single product area start --> */}
                      <div
                        className="signle-product-start"
                        
                        
                      >
                       
                          <img
                            // src="assets/images/portfolio/portfolio-4.png"
                            src = "../assets/images/Exam_Snapshots/Picture4.png"
                            alt="corporate_business"
                            style={{height : "300px" , width : "400px"}}
                          />
                       
                        {/* <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Executive Layout Set</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div> */}
                      </div>
                      {/* <!-- single product area end --> */}
                    </div>
                    <div className="swiper-slide">
                      {/* <!-- single product area start --> */}
                      <div
                        className="signle-product-start"
                        
                        
                      >
                       
                          <img
                            // src="assets/images/portfolio/portfolio-5.png"
                            src = "../assets/images/Exam_Snapshots/Picture5.png"
                            alt="corporate_business"
                            style={{height : "300px" , width : "400px"}}
                          />
                       
                        {/* <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Professional Design</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div> */}
                      </div>
                      {/* <!-- single product area end --> */}
                    </div>
                    <div className="swiper-slide">
                      {/* <!-- single product area start --> */}
                      <div
                        className="signle-product-start"
                        
                        
                      >
                       
                          <img
                            // src="assets/images/portfolio/portfolio-6.png"
                            src = "../assets/images/Exam_Snapshots/Picture6.png"
                            alt="corporate_business"
                            style={{height : "300px" , width : "400px"}}
                          />
                       
                        {/* <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Business Layout Library</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div> */}
                      </div>
                      {/* <!-- single product area end --> */}
                    </div>

                    <div className="swiper-slide">
                      {/* <!-- single product area start --> */}
                      <div
                        className="signle-product-start"
                        
                        
                      >
                      
                          <img
                            // src="assets/images/portfolio/portfolio-6.png"
                            src = "../assets/images/Exam_Snapshots/Picture7.png"
                            alt="corporate_business"
                            style={{height : "300px" , width : "400px"}}
                          />
                    
                        {/* <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Business Layout Library</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div> */}
                      </div>
                      {/* <!-- single product area end --> */}
                    </div>

                    <div className="swiper-slide">
                      {/* <!-- single product area start --> */}
                      <div
                        className="signle-product-start"
                        
                        
                      >
                       
                          <img
                            // src="assets/images/portfolio/portfolio-6.png"
                            src = "../assets/images/Exam_Snapshots/Picture8.png"
                            alt="corporate_business"
                            style={{height : "300px" , width : "400px"}}
                          />
                     
                        {/* <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Business Layout Library</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div> */}
                      </div>
                      {/* <!-- single product area end --> */}
                    </div>

                    <div className="swiper-slide">
                      {/* <!-- single product area start --> */}
                      <div
                        className="signle-product-start"
                        
                        
                      >
                       
                          <img
                            // src="assets/images/portfolio/portfolio-6.png"
                            src = "../assets/images/Exam_Snapshots/Picture9.png"
                            alt="corporate_business"
                            style={{height : "300px" , width : "400px"}}
                          />
                      
                        {/* <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Business Layout Library</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div> */}
                      </div>
                      {/* <!-- single product area end --> */}
                    </div>

                    <div className="swiper-slide">
                      {/* <!-- single product area start --> */}
                      <div
                        className="signle-product-start"
                        
                        
                      >
                      
                          <img
                            // src="assets/images/portfolio/portfolio-6.png"
                            src = "../assets/images/Exam_Snapshots/Picture10.png"
                            alt="corporate_business"
                            style={{height : "300px" , width : "400px"}}
                          />
                     
                        {/* <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Business Layout Library</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div> */}
                      </div>
                      {/* <!-- single product area end --> */}
                    </div>

                    <div className="swiper-slide">
                      {/* <!-- single product area start --> */}
                      <div
                        className="signle-product-start"
                        
                        
                      >
                     
                          <img
                            // src="assets/images/portfolio/portfolio-6.png"
                            src = "../assets/images/Exam_Snapshots/Picture11.png"
                            alt="corporate_business"
                            style={{height : "300px" , width : "400px"}}
                          />
                      
                        {/* <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Business Layout Library</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div> */}
                      </div>
                      {/* <!-- single product area end --> */}
                    </div>

                    <div className="swiper-slide">
                      {/* <!-- single product area start --> */}
                      <div
                        className="signle-product-start"
                        
                        
                      >
                     
                          <img
                            // src="assets/images/portfolio/portfolio-6.png"
                            src = "../assets/images/Exam_Snapshots/Picture12.png"
                            alt="corporate_business"
                            style={{height : "300px" , width : "400px"}}
                          />
                     
                        {/* <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Business Layout Library</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div> */}
                      </div>
                      {/* <!-- single product area end --> */}
                    </div>

                    <div className="swiper-slide">
                      {/* <!-- single product area start --> */}
                      <div
                        className="signle-product-start"
                        
                        
                      >
                       
                          <img
                            // src="assets/images/portfolio/portfolio-6.png"
                            src = "../assets/images/Exam_Snapshots/Picture13.png"
                            alt="corporate_business"
                            style={{height : "300px" , width : "400px"}}
                          />
                     
                        {/* <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Business Layout Library</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div> */}
                      </div>
                      {/* <!-- single product area end --> */}
                    </div>

                    <div className="swiper-slide">
                      {/* <!-- single product area start --> */}
                      <div
                        className="signle-product-start"
                        
                        
                      >
                       
                          <img
                            // src="assets/images/portfolio/portfolio-6.png"
                            src = "../assets/images/Exam_Snapshots/Picture14.png"
                            alt="corporate_business"
                            style={{height : "300px" , width : "400px"}}
                          />
                       
                        {/* <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Business Layout Library</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div> */}
                      </div>
                      {/* <!-- single product area end --> */}
                    </div>
                  </div>
                  <div className="swiper-pagination"></div>
                  <div
                    className="swiper-button-next"
                    data-tmp-cursor="md transparent fw-bold"
                    data-tmp-cursor-text="Next"
                  ></div>
                  <div
                    className="swiper-button-prev"
                    data-tmp-cursor="md transparent fw-bold"
                    data-tmp-cursor-text="Prev"
                  ></div>
                </div>
              </div>
              {/* <!-- product swiper area end --> */}
            </div>
          </div>
        </div>
      </div>
      {/* <!-- tmp product area end --> */}
      <ExamProcessInfographic/> 
      <ExaminationProcessCards/>
      <ExaminationFeaturesRoadmap/>
      <SecurityManagement/>
      <QualityControlManagement/>
     <ModuleCoverage/>
      <CrisisManagement/>
      <InventoryManagement/>
      <ManpowerManagement/>

      {/* <!-- tmp counterup section area start --> */}
      <div className="tmp-section-gapTop tmp-counterup-area" ref={counterRef}>
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
              <div className="single-counterup-area-agency">
                <div className="icon">
                  <img
                    src="assets/images/counter/05.svg"
                    alt="agency-service"
                  />
                </div>
                <div className="information">
                  <div className="counter-details">
                    <h2 className="title">
                      {/*<span className="counter animated fadeInDownBig">
                        858
                      </span>
                      +*/}
                      <span className="counter">{counters.projects}</span>+
                    </h2>
                    <p className="disc">Successful Projects</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
              <div className="single-counterup-area-agency">
                <div className="icon">
                  <img
                    src="assets/images/counter/08.svg"
                    alt="agency-service"
                  />
                </div>
                <div className="information">
                  <div className="counter-details">
                    <h2 className="title">
                      {/*<span className="counter animated fadeInDownBig">
                        858
                      </span>
                      k+*/}
                      <span className="counter">{counters.clients}</span>+
                    </h2>
                    <p className="disc">Happy Clients</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
              <div className="single-counterup-area-agency">
                <div className="icon">
                  <img
                    src="assets/images/counter/06.svg"
                    alt="agency-service"
                  />
                </div>
                <div className="information">
                  <div className="counter-details">
                    <h2 className="title">
                      {/*<span className="counter animated fadeInDownBig">
                        758
                      </span>
                      +*/}
                      <span className="counter">{counters.media}</span>+
                    </h2>
                    <p className="disc">Media Active</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
              <div className="single-counterup-area-agency">
                <div className="icon">
                  <img
                    src="assets/images/counter/07.svg"
                    alt="agency-service"
                  />
                </div>
                <div className="information">
                  <div className="counter-details">
                    <h2 className="title">
                      {/*<span className="counter animated fadeInDownBig">
                        258
                      </span>
                      +*/}
                      <span className="counter">{counters.experience}</span>+
                    </h2>
                    <p className="disc">Skill Experience</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- tmp counterup section area end --> */}

      {/* <!-- Start Contact Area  --> */}
      <div className="contact-area-three agency tmp-section-gapTop" style={{marginBottom : "50px"}}>
        <div className="bg-shape">
          <img src="assets/images/cta/02.png" alt="bussiness-contact" />
        </div>
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-5">
              <div className="contact-inner-agency">
                <div
                  className="section-head section-head-one-side text-align-left"
                  data-sal-delay="150"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  <span className="title">Contact Us</span>
                  <p className="description">
                   Have questions or ready to get started? Reach out to our team—we're here to help you grow and succeed.
                  </p>
                </div>

                <ul
                  className="ft-link ft-link-style-three"
                  data-sal-delay="250"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  <li>
                    <div className="single-contact background-transparent">
                      <div className="icon">
                        <i className="fa-light fa-phone"></i>
                      </div>
                      <div className="content">
                        <span>Call Us</span>
                        <Link className="contact-here" to="#">
                          +919057000445 
                          +919057000446
                        </Link>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="single-contact background-transparent">
                      <div className="icon">
                        <i className="fa-solid fa-envelope-open-text"></i>
                      </div>

                      <div className="content">
                        <span>E-mail</span>
                        <Link className="contact-here" to="#">
                          info@starparth.com
                        </Link>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="single-contact background-transparent">
                      <div className="icon">
                        <i className="fa-solid fa-map-location-dot"></i>
                      </div>
                      <div className="content">
                        <span>Address</span>
                        <Link className="contact-here" to="#">
                      G2 Aanchal Apartment 1/55 Roshan Marg
                      Chitrakoot Jaipur Rajasthan 302021
                        </Link>
                      </div>
                    </div>
                  </li>
                </ul>

                <div
                  className="tmp-tag-list tag-list-one"
                  data-sal-delay="350"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  <Link className="tag-list" to="https://www.facebook.com/starparthexamination/">
                    Facebook
                  </Link>
                  <Link className="tag-list" to="https://x.com/Starparthtech">
                    Twitter
                  </Link>
                  <Link className="tag-list" to="#">
                    Linkedin
                  </Link>
                  <Link className="tag-list" to="#">
                    Skype
                  </Link>
                  <Link className="tag-list" to="#">
                    Pinterest
                  </Link>
                </div>
              </div>
            </div>
            <div
              className="col-lg-7"
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="contact-inner">
                <div className="section-head section-head-one-side text-align-left">
                  <span className="title">Let's Appoinment</span>
                  <p className="description">
                Let’s connect and explore how Starparth can bring your vision to life.
                  </p>
                </div>
                <div className="contact-form style-two">
                  <form id="contact-form" onSubmit={handleSubmit} noValidate>
                    <div className="contact-form-wrapper row">
                        <div className="form-honeypot" aria-hidden="true">
                          <input type="text" name="company_website" tabIndex={-1}
                            autoComplete="off" {...fieldProps("company_website")} />
                        </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            className="input-field"
                            name="name"
                            placeholder="Name"
                            id="contact-name"
                            type="text"
                            value={formData.name}
	                          onChange={handleInputChange}
                            required
                          />
                            <Err name="name" />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            className="input-field"
                            name="phone"
                            placeholder="Phone"
                            type="text"
                            value={formData.phone}
	                          onChange={handleInputChange}
                            required
                          />
                            <Err name="phone" />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            className="input-field"
                            name="email"
                            placeholder="Email"
                            type="email"
                            value={formData.email}
	                          onChange={handleInputChange}
                            required
                          />
                            <Err name="email" />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            className="input-field"
                            type="text"
                            id="subject"
                            placeholder="Website"
                            name="website"
                          	value={formData.website}
	                          onChange={handleInputChange}
                          />
                            <Err name="website" />
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="form-group">
                          <textarea
                            className="input-field"
                            placeholder="How can we help"
                            name="message"
                            id="contact-message"
                            value={formData.message}
	                          onChange={handleInputChange}
                          ></textarea>
                            <Err name="message" />
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="form-submit-group">
                          <button
                            name="submit"
                            className="tmp-btn btn-primary"
                            type="submit"
                            id="submit"
	                          disabled={isLoading}
                          >
                            {isLoading ? 'Sending…' : 'Submit Now'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- End Contact Area  --> */}

      {/* <!-- Tmp Blog Area Start  --> */}
      {/* <div className="tmp-blog-area tmp-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="header-top-inner">
                <div className="section-head pb--30  text-align-left">
                  <span className="subtitle color-primary">LATEST BLOG</span>
                  <h2 className="title split-collab">Latest news & articles</h2>
                </div>
                <div className="btn-group">
                  <Link to="#" className="tmp-btn btn-primary">
                    View All Post
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="row g-5 mt--10">
            <div
              className="col-lg-4"
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="single-blog blog-style-three">
                <div className="blog-inner">
                  <div className="thumbnail">
                    <Link to="/blog/details">
                      <img
                        src="assets/images/blog/blog-1.png"
                        alt="Business Consulting Blog"
                      />
                    </Link>
                  </div>
                  <div className="blog-content text-center">
                    <div className="blog-head">
                      <span className="name">20 JAN 2023</span>
                      <span className="designation">Consulting</span>
                    </div>
                    <div className="blog-body">
                      <Link to="/blog/details" className="title-area">
                        <h4 className="title">
                          Consulted admitting wooded is power acuteness.
                        </h4>
                      </Link>
                      <Link className="btn-read-more" to="/blog/details">
                        <span className="read-more-text">Read More</span>
                        <span className="read-more-icon">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-lg-4"
              data-sal-delay="250"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="single-blog blog-style-three">
                <div className="blog-inner">
                  <div className="thumbnail">
                    <Link to="/blog/details">
                      <img
                        src="assets/images/blog/blog-2.png"
                        alt="Business Consulting Blog"
                      />
                    </Link>
                  </div>
                  <div className="blog-content text-center">
                    <div className="blog-head">
                      <span className="name">20 JAN 2023</span>
                      <span className="designation">Consulting</span>
                    </div>
                    <div className="blog-body">
                      <Link to="/blog/details" className="title-area">
                        <h4 className="title">
                          Grow your business strategy with business consulting.
                        </h4>
                      </Link>
                      <Link className="btn-read-more" to="/blog/details">
                        <span className="read-more-text">Read More</span>
                        <span className="read-more-icon">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-lg-4"
              data-sal-delay="350"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="single-blog blog-style-three">
                <div className="blog-inner">
                  <div className="thumbnail">
                    <Link to="/blog/details">
                      <img
                        src="assets/images/blog/blog-3.png"
                        alt="Business Consulting Blog"
                      />
                    </Link>
                  </div>
                  <div className="blog-content text-center">
                    <div className="blog-head">
                      <span className="name">20 JAN 2023</span>
                      <span className="designation">Consulting</span>
                    </div>
                    <div className="blog-body">
                      <Link to="/blog/details" className="title-area">
                        <h4 className="title">
                          Facilis dolor eques about under official,presentism.
                        </h4>
                      </Link>
                      0
                      <Link className="btn-read-more" to="/blog/details">
                        <span className="read-more-text">Read More</span>
                        <span className="read-more-icon">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <!-- Tmp Blog Area Start  --> */}

      {/* <!-- Start Testimonial with brand  --> */}
      {/* <div className="testimonial-with-brand">
        <!-- Start Testimonial Area  -->
        <div className="testimonial-brand-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="testimonials-button-area" style={{marginTop:"70px"}}>
                  <div className="section-head text-align-left">
                    <div className="section-sub-title">
                      <img
                        src="assets/images/services/section-custom-menubar.png "
                        alt="Corporate_service"
                      />
                      <span className="subtitle">Client’s Testimonials</span>
                    </div>
                    <h2 className="title split-collab">
                      What People Say About <br /> Our Company
                    </h2>
                  </div>

                  <div className="button-next-prev">
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <!-- Slider main container -->
                <div className="swiper-style-one">
                  <div className="swiper-container-style-two">
                    <!-- Additional required wrapper -->
                    <div className="swiper-wrapper">
                      <div className="swiper-slide">
                        <div className="single-card card-horizontal agency-testimonials">
                          <div className="card-inner" style={{marginTop:"-10px"}}>
                            <div className="content">
                              <div className="rating rating-style-three">
                                <div className="stars-group">
                                  <div className="star">
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star-half-stroke"></i>
                                  </div>
                                </div>
                              </div>
                              <p className="description">
                                Its incredible. its really wonderful. company
                                has completely surpassed our expect. Urna
                                porttitor rhoncus dolor purus non enim praesent
                                at the facilisis lectus. Adipiscing tristique
                                risus.
                              </p>
                              <div className="content content-without-bg">
                                <div className="name">Clade Owen</div>
                                <div className="designation">
                                  CEO &amp; Founder
                                </div>
                              </div>
                            </div>
                            <div className="thumbnail">
                              <img
                                src="assets/images/testimonial/testimonial-1.jpg"
                                alt="testimonial"
                              />
                              <div className="icon icon-quote">
                                <i className="fa-duotone fa-quote-left"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="single-card card-horizontal agency-testimonials">
                          <div className="card-inner">
                            <div className="content">
                              <div className="rating rating-style-three">
                                <div className="stars-group">
                                  <div className="star">
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star-half-stroke"></i>
                                  </div>
                                </div>
                              </div>
                              <p className="description">
                                Its incredible. its really wonderful. company
                                has completely surpassed our expect. Urna
                                porttitor rhoncus dolor purus non enim praesent
                                at the facilisis lectus. Adipiscing tristique
                                risus.
                              </p>

                              <div className="content content-without-bg">
                                <div className="name">Nicolas Alvin</div>
                                <div className="designation">Web Developer</div>
                              </div>
                            </div>
                            <div className="thumbnail">
                              <img
                                src="assets/images/testimonial/testimonial-2.jpg"
                                alt="testimonial"
                              />
                              <div className="icon icon-quote">
                                <i className="fa-duotone fa-quote-left"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="single-card card-horizontal agency-testimonials">
                          <div className="card-inner">
                            <div className="content">
                              <div className="rating rating-style-three">
                                <div className="stars-group">
                                  <div className="star">
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star-half-stroke"></i>
                                  </div>
                                </div>
                              </div>
                              <p className="description">
                                Its incredible. its really wonderful. company
                                has completely surpassed our expect. Urna
                                porttitor rhoncus dolor purus non enim praesent
                                at the facilisis lectus. Adipiscing tristique
                                risus.
                              </p>
                              <div className="content content-without-bg">
                                <div className="name">Lara Willie</div>
                                <div className="designation">UX Designer</div>
                              </div>
                            </div>
                            <div className="thumbnail">
                              <img
                                src="assets/images/testimonial/testimonial-1.jpg"
                                alt="testimonial"
                              />
                              <div className="icon icon-quote">
                                <i className="fa-duotone fa-quote-left"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="single-card card-horizontal agency-testimonials">
                          <div className="card-inner">
                            <div className="content">
                              <div className="rating rating-style-three">
                                <div className="stars-group">
                                  <div className="star">
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star-half-stroke"></i>
                                  </div>
                                </div>
                              </div>
                              <p className="description">
                                Its incredible. its really wonderful. company
                                has completely surpassed our expect. Urna
                                porttitor rhoncus dolor purus non enim praesent
                                at the facilisis lectus. Adipiscing tristique
                                risus.
                              </p>
                              <div className="content content-without-bg">
                                <div className="name">Clade Herbert</div>
                                <div className="designation">
                                  CEO and Founder
                                </div>
                              </div>
                            </div>
                            <div className="thumbnail">
                              <img
                                src="assets/images/testimonial/testimonial-2.jpg"
                                alt="testimonial"
                              />
                              <div className="icon icon-quote">
                                <i className="fa-duotone fa-quote-left"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- If we need navigation buttons -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        // {/* <!-- End Testimonial Area  --> */}

        {/* <!-- End Brand Area  --> */}
      {/* </div> */} 
      {/* <!-- End Testimonial with brand  --> */}

      {/* <!-- Start team area  --> */}
      {/* <div className="team-area tmp-section-gap bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-head">
                <div className="section-sub-title center-title">
                  <img
                    src="assets/images/services/section-custom-menubar.png "
                    alt="Corporate services"
                  />
                  <span>OUR EXPERT TEAM</span>
                </div>
                <h2 className="section-title split-collab">
                  Meet Our Expert Team
                </h2>
              </div>
            </div>
          </div>
          <div className="row g-5">
            <div
              className="col-lg-4 col-md-6 col-sm-12 col-12"
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="single-team">
                <Link
                  to="/team/details"
                  className="thumbnail"
                  data-tmp-cursor="lg transparent fw-bold"
                  data-tmp-cursor-text="View Details"
                >
                  <img
                    src="assets/images/team/team-2.png"
                    alt="Corporate team"
                  />
                </Link>
                <div className="content">
                  <div className="team-name content-with-bg">
                    <Link to="#" className="name-area">
                      <h6 className="name">Clade Owen</h6>
                    </Link>
                    <div className="designation">CEO & Founder</div>
                  </div>
                  <div className="share-icon-style-one">
                    <ul className="social-icons social-icons-with-bg">
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-facebook-f"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-linkedin-in"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-twitter"></i>
                        </Link>
                      </li>
                    </ul>
                    <i className="fa-sharp fa-solid fa-share-nodes"></i>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 col-sm-12 col-12"
              data-sal-delay="250"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="single-team">
                <Link
                  to="/team/details"
                  className="thumbnail"
                  data-tmp-cursor="lg transparent fw-bold"
                  data-tmp-cursor-text="View Details"
                >
                  <img
                    src="assets/images/team/team-3.png"
                    alt="Corporate team"
                  />
                </Link>
                <div className="content">
                  <div className="team-name content-with-bg">
                    <Link to="#" className="name-area">
                      <h6 className="name">John Lee</h6>
                    </Link>
                    <div className="designation">CEO & Founder</div>
                  </div>
                  <div className="share-icon-style-one">
                    <ul className="social-icons social-icons-with-bg">
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-facebook-f"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-linkedin-in"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-twitter"></i>
                        </Link>
                      </li>
                    </ul>
                    <i className="fa-sharp fa-solid fa-share-nodes"></i>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 col-sm-12 col-12"
              data-sal-delay="350"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="single-team">
                <Link
                  to="/team/details"
                  className="thumbnail"
                  data-tmp-cursor="lg transparent fw-bold"
                  data-tmp-cursor-text="View Details"
                >
                  <img
                    src="assets/images/team/team-1.png"
                    alt="Corporate team"
                  />
                </Link>
                <div className="content">
                  <div className="team-name content-with-bg">
                    <Link to="#" className="name-area">
                      <h6 className="name">William John</h6>
                    </Link>
                    <div className="designation">CEO & Founder</div>
                  </div>
                  <div className="share-icon-style-one">
                    <ul className="social-icons social-icons-with-bg">
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-facebook-f"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-linkedin-in"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-twitter"></i>
                        </Link>
                      </li>
                    </ul>
                    <i className="fa-sharp fa-solid fa-share-nodes"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <!-- End team area  --> */}

      {/* <!-- Start Footer Area  --> */}
      {/* <!-- Start Footer Area  --> */}
      {/* <footer className="footer-area footer-style-one-wrapper bg-color-footer bg_images tmp-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="subscribe-area subscribe-style-1">
                <div className="subscribe-inner">
                  <div className="title">Subscribe to Newsletter</div>
                  <form action="#" className="newsletter-form-1 mt--40">
                    <input type="email" placeholder="Your Email" required />
                    <button type="submit" className="tmp-btn btn-primary">
                      Subscribe Now{" "}
                      <i className="fa-sharp fa-regular fa-paper-plane"></i>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-main footer-style-one">
            <div className="row g-5">
              <div className="col-lg-4 col-md-6">
                <div className="single-footer-wrapper border-right mr--20">
                  <div className="logo">
                    <Link to="/">
                      <img src="assets/images/logo/logo-02.svg" alt="logo" />
                      <img height="61" width="188" src="/assets/images/logo/starpath-logo.svg" alt="logo" />
                    </Link>
                  </div>

                  <p className="description">
                    Proin Pretium Sem Libero, Nec Aliquet Augue Lobortis In.
                    Phasellus Nibh Quam, Molestie Id Est Sit Amet, Luctus
                    Pulvinar
                  </p>

                  <div className="day-time">
                    <div className="icon">
                      <i className="fa-solid fa-alarm-clock"></i>
                    </div>
                    <div className="content">
                      <div className="day">Sunday - Friday:</div>
                      <div className="time">9:00 AM – 8:00 PM</div>
                    </div>
                  </div>

                  <ul className="social-icons solid-social-icons rounded-social-icons">
                    <li>
                      <Link to="#">
                        <i className="fa-brands fa-facebook-f"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="fa-brands fa-linkedin-in"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="fa-brands fa-twitter"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="fa-brands fa-instagram"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-md-6">
                <div className="single-footer-wrapper pl-50 pl_md--0 pl_sm--0">
                  <h5 className="ft-title">Quick Link</h5>
                  <ul className="ft-link">
                    <li>
                      <Link to="/about">About Company</Link>
                    </li>
                    <li>
                      <Link to="/team">Meet Our Team</Link>
                    </li>
                    <li>
                      <Link to="/service">Our Services</Link>
                    </li>
                    <li>
                      <Link to="/blog">News & Media</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>

                    <li>
                      <Link to="/faq">Support</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="single-footer-wrapper pr--15">
                  <h5 className="ft-title">Recent Post</h5>

                  <div className="single-post">
                    <div className="thumbnail">
                      <img
                        src="assets/images/footer/small-post.jpg"
                        alt="Business_Corporate"
                      />
                    </div>
                    <div className="content">
                      <div className="date">
                        <i className="fa-light fa-calendar-days"></i>
                        <span>12 Feb, 2022</span>
                      </div>

                      <Link to="/blog/details">
                        <h6 className="title">
                          Day tree hide from hath gathered multy
                        </h6>
                      </Link>
                    </div>
                  </div>

                  <div className="single-post">
                    <div className="thumbnail">
                      <img
                        src="assets/images/footer/small-post-2.jpg"
                        alt="Business_Corporate"
                      />
                    </div>
                    <div className="content">
                      <div className="date">
                        <i className="fa-light fa-calendar-days"></i>
                        <span>12 Feb, 2022</span>
                      </div>

                      <Link to="/blog/details">
                        <h6 className="title">
                          Saving Time Achieving Success in Business
                        </h6>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="single-footer-wrapper">
                  <h5 className="ft-title">Official info:</h5>
                  <ul className="ft-link">
                    <li className="ft-location">
                      5919 Trussville Crossings Pkwy, new Dusting town, Austria
                    </li>

                    <li>
                      <div className="single-contact">
                        <div className="icon">
                          <i className="fa-solid fa-envelope-open-text"></i>
                        </div>

                        <div className="content">
                          <span>E-mail:</span>
                          <Link to="mailto:webmaster@example.com">
                            info@uibundle.com
                          </Link>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="single-contact">
                        <div className="icon">
                          <i className="fa-light fa-phone"></i>
                        </div>
                        <div className="content">
                          <span>Phone:</span>
                          <Link to="tel:+4733378901">+123 34598768</Link>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="copyright-area-one">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-wrapper">
                <p>
                  © Copyright 2024. All Rights Reserved by{" "}
                  <Link to="#">Themes-Park</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <!-- End Footer Area  --> */}
      {/* <!-- End Footer Area  --> */}

      <div
        id="overlay_every-where"
        data-tmp-cursor="md text-black dark:text-white opacity-10"
        data-tmp-cursor-icon="fa-regular fa-x fa-fw"
      ></div>

      {/* <!-- progress area start --> */}
      <div className="progress-wrap">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
     
      <ExamCumulativeChart/>
      <GrowthChart/>
      <DifficultiesFaced/>
      <WhyChooseUs/>
      {/* <!-- progress area end --> */}

      {/* <!-- ==================== Start Loading ==================== --> */}

      {/* <div className="loader-wrap">
        <svg viewBox="0 0 1000 1000" preserveAspectRatio="none">
            <path id="svg" d="M0,1005S175,995,500,995s500,5,500,5V0H0Z"></path>
        </svg>

        <div className="loader-wrap-heading">
            <div className="load-text">
                <span>L</span>
                <span>o</span>
                <span>Link
                </span>
                <span>d</span>
                <span>i</span>
                <span>n</span>
                <span>g</span>
            </div>
        </div>
    </div> */}

      {/* <!-- ==================== End Loading ==================== --> */}
    </div>
  );
};

export default Agency_Demo;
